// @flow
import ElectRoleFillerPart from 'components/proposals/Part/ElectRoleFiller'
import LinkedRolePart from 'components/proposals/Part/LinkedRole'
import MoveItemsPart from 'components/proposals/Part/MoveItems'
import PlaceholderPart from 'components/proposals/Part/Placeholder'
import PolicyPart from 'components/proposals/Part/Policy'
import RolePart from 'components/proposals/Part/Role'

import {type Change} from './index'

function componentClass({type}: Change): any {
  if (!type)
    return PlaceholderPart

  if (type === 'CreateLinkedRole' || type === 'UpdateLinkedRole')
    return LinkedRolePart

  if (type === 'CreateRole' || type === 'UpdateRole' || type === 'DestroyRole')
    return RolePart

  if (type === 'CreatePolicy' || type === 'UpdatePolicy' || type === 'DestroyPolicy')
    return PolicyPart

  if (type === 'MoveItems')
    return MoveItemsPart

  if (type === 'ElectRoleFiller')
    return ElectRoleFillerPart

  throw new Error(`Component not found for unknown changeType: ${type}`)
}

export default componentClass
